<div
  class="photo-view-container"
  [ngClass]="{ 'web-app': isWebApp }"
  [ngStyle]="{
    width: isWebApp
      ? 100 * (window.devicePixelRatio > 1 ? 1 : window.devicePixelRatio) + '%'
      : 'inherit'
  }"
>
  <ion-label position="stacked" *ngIf="label">{{ label }}</ion-label>

  <div class="photo-buttons">
    <ion-button
      style="height: 40px"
      fill="clear"
      class="left"
      (click)="isWebApp ? addPhotoFromCamera() : choosePhotoVideoOption()"
    >
      <ion-icon slot="start" src="./assets/icon/image.svg"></ion-icon>

      <ng-container *ngIf="isWebApp; else takePhotOrVideo">
        {{ "SHARED_TEXT.MEDIA.TAKE_PHOTO" | translate }}
      </ng-container>
      <ng-template #takePhotOrVideo>{{
        "SHARED_TEXT.MEDIA.TAKE_PHOTO_VIDEO" | translate
      }}</ng-template>
    </ion-button>

    <span>Or</span>

    <ion-button
      style="height: 40px"
      fill="clear"
      class="right"
      (click)="addFileLibrary()"
    >
      <ion-icon slot="start" src="./assets/icon/folder.svg"></ion-icon>
      {{ "SHARED_TEXT.MEDIA.CHOOSE_AN_ATTACHMENT" | translate }}
    </ion-button>
  </div>
  <input
    type="file"
    #videoFileInput
    accept="video/*"
    style="display:none"
    (change)="onVideoFileSelected($event)"
  />
  <div *ngFor="let element of attachementList; let elementIndex = index">
    <div class="image-view">
      <div class="header-items">
        <div class="titleField">
          <ion-icon
            class="titleIcon"
            [name]="
              expandedList[elementIndex] !== null
                ? this.isVideoList[elementIndex]
                  ? 'caret-forward-outline'
                  : 'image-outline'
                : 'document-outline'
            "
            slot="icon-only"
          ></ion-icon>
          <ion-label style="color: darkslategrey">{{
            element?.name
          }}</ion-label>
        </div>
        <div class="close-btn">
          <ion-button
            *ngIf="
              photoThumbnailList[elementIndex] || isVideoList[elementIndex]
            "
            class="edit-btn"
            fill="clear"
            (click)="expandImage(elementIndex)"
          >
            <ion-icon
              *ngIf="!expandedList[elementIndex]"
              name="chevron-down-outline"
              slot="icon-only"
            ></ion-icon>
            <ion-icon
              *ngIf="expandedList[elementIndex]"
              name="chevron-up-outline"
              slot="icon-only"
            ></ion-icon>
          </ion-button>
          <ion-button
            *ngIf="
              !isVideoList[elementIndex] && photoThumbnailList[elementIndex]
            "
            class="edit-btn"
            fill="clear"
            (click)="editPhoto(elementIndex)"
          >
            <ion-icon name="pencil-outline" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button fill="clear" (click)="photoRemoved(elementIndex)">
            <ion-icon name="close" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      </div>

      <ng-container
        *ngIf="isVideoList[elementIndex] && expandedList[elementIndex]"
      >
        <video
          controls="controls"
          preload="metadata"
          webkit-playsinline="webkit-playsinline"
          class="videoPlayer"
        >
          <source
            *ngIf="
              !UtilService.IsBase64Sring(isVideoList[elementIndex]);
              else base64Video
            "
            [src]="sanitize(isVideoList[elementIndex])"
            type="video/mp4"
          />
          <source
            *ngIf="
              !UtilService.IsBase64Sring(attachementList[elementIndex]?.url);
              else base64Video
            "
            [src]="sanitize(attachementList[elementIndex]?.url)"
            type="video/mp4"
          />
          <ng-template #base64Video>
            <source [src]="isVideoList[elementIndex]" />
          </ng-template>
        </video>
      </ng-container>
      <ng-container
        *ngIf="expandedList[elementIndex] && !isVideoList[elementIndex]"
      >
        <ion-img
          *ngIf="photoThumbnailList[elementIndex]"
          [src]="photoThumbnailList[elementIndex]"
        ></ion-img>
        <p *ngIf="photoThumbnailList[elementIndex]"></p>
        <!-- [src]="Capacitor.convertFileSrc(image)" -->
      </ng-container>
    </div>
  </div>
</div>
